









































































































































































import ComponentSelector from "../Selectors/ComponentSelector.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { ppm } from "../../api/ppm/ppm";
import { group } from "../../api/group/group";
import { component } from "../../api/component/component";
import { status } from "../../api/status/status";
import Moment from "moment";

@Component({
  name: "PPMFilters2",
  props: {
    filters: {
      fromDate: "",
      toDate: "",
      system: "",
      component: "",
      status: "",
      maintenance_period: ""
    }
  },
  model: {
    prop: "filters",
    event: "change"
  },
   watch: {
    date: function(val) {
      this.$props.filters.fromDate = val;
    }
  }
})
export default class WorkOrderFilters extends Vue {
  public loading: boolean = false;
  public activeName: any = "1";
  public systems: any[] = [];
  public componentList: any[] = [];
  public visibleComponents: any[] = [];
  public statuses: any[] = [];
  public maintenancePeriodOptions: any[] = [];
  public maintenancePeriod: any = '';
  public date: Date = new Date();
   public update() {
    this.$forceUpdate();
  }
  public async mounted() {
    this.loading = true;
    this.maintenancePeriodYearOptions();
    await this.getGroupList();
    await this.getComponentList();
     await this.getStatusList();
    this.$props.filters.fromDate = new Date(
      new Date().setDate(new Date().getDate() - 10)
    );
    this.date = new Date(new Date().setDate(new Date().getDate() - 10));
    this.loading = false;
  }

  public async maintenancePeriodYearOptions(){
    // ftiaxnw epiloges gia to maintenance period pedio
    var currentYear = Moment(new Date()).format("YYYY");
    var year = parseInt(currentYear);
    var currentMonth = Moment(new Date()).format("MM")
    //  this.currentMonth = Moment(new Date(2019,9,2)).format("MM")
    var month = parseInt(currentMonth)
    if(month <= 9){

      year=year-1

    }

    do {
      // year= year +"-"+year+1
      console.log(typeof year)
      console.log("typeofyear1")
      console.log(year+1)
      console.log("typeofyear2")
      var yeartest2=year+1
      let yeartest= year+"-"+yeartest2
      this.maintenancePeriodOptions.push(yeartest);
      year -= 1;
    } while (2019 <= year);
  }

  public async getGroupList() {
    await group
      .getAllGroups(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then(resp => {
          let groupList = JSON.parse(JSON.stringify(resp));
          for (const g of groupList) {
            switch (g.group_number) {
              case 2:
                this.systems.push({ value: g.id, label: g.literal });
                break;
            }
          }
        });
      });
  }
  
  
  public async getComponentList() {
    await component
      .getAllComponents(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then((resp: any) => {
          this.componentList = JSON.parse(JSON.stringify(resp));
        });
      });
  }

  
  public remoteMethod(query: string) {
    console.log(this.componentList);
    if (query !== "") {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.visibleComponents = this.componentList.filter(item =>
          item.literal.toLowerCase().includes(query.toLowerCase())
        );
      }, 200);
    } else {
      this.visibleComponents = [];
    }
  }
   public async getStatusList() {
    await status
      .getAllStatuses(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then(resp => {
          let i = 0;
          while (i <= JSON.parse(JSON.stringify(resp)).length - 1) {
            this.statuses.push({
              value: JSON.parse(JSON.stringify(resp))[i].id,
              label: JSON.parse(JSON.stringify(resp))[i].literal
            });
            i++;
          }
        });
      });
  }
}
